export enum ConsentStatus {
  NotStarted = 0,
  Completed = 1,
  Error = 2,
}
